import { orgBookings, orgBookingsCount, orgPackages } from '../../../api/supportAdmin';
import errorHandle from '../../../utils/errorHandle';

export const fetchSupBooking = async (
    limit,
    setBookings,
    setStats,
    setLoading,
    offset,
    orgId,
    packid = '',
    packDateid = '',
    selectedType = 'upcoming',
    datesType,
    group,
    serviceType
) => {
    setLoading(true);
    try {
        const date = selectedType === 'upcoming' ? 'next' : 'previous';
        const res = await orgBookings(orgId, date, limit, offset, packid, packDateid, datesType, serviceType, group);
        setBookings(res?.data?.data);
        setStats(res?.data?.stats);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export const getTrips = async (orgId, setTrips, datesType, group, setLoading, serviceType) => {
    setLoading(true);

    try {
        const res = await orgPackages(orgId, 'active', 50, 0, datesType, group, serviceType, '');

        setTrips(res.data);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export const bookingCount = async (
    setTotalCount,
    setLoading,
    orgId,
    trip = '',
    selectedDate = '',
    type = 'upcoming',
    datesType,
    group,
    serviceType
) => {
    setLoading(true);
    try {
        const res = await orgBookingsCount(
            orgId,
            trip,
            selectedDate,
            type === 'upcoming' ? 'next' : 'previous',
            datesType,
            group,
            serviceType
        );
        setTotalCount(res.data.bookCount);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};
